import React from 'react'
import { withRouter } from "react-router-dom";
import { FormComponent } from '../../../../components/form/DynamicForm';
import { Form } from '../../../../components/form/DynamicFormTs';
import Http from '../../../../Http';

class ClienteVentas extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'cliente/administrativo', saveUrl: 'cliente/save', backUrl: '/Catalogo/Cliente/' + this.props.match.params.id + '/Destinatarios' },
      new Form([
        Form.Field('select', 'cliente_id_api_guia_status', 'Estatus de la Guia', '', [], 12),
      ], ['Guardar']), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds(this.props.match.params.id)
  }

  formData = async (form) => {
    const Res = await Http.get(`cliente/form/api`);
    let newForm = form;
    if (!Res.error) {
      if (Res.data && Res.data.status) {
        newForm = Form.FieldOptions(newForm, 'cliente_id_api_guia_status', Res.data.status, 'id', 'descripcion');
      }
      return newForm;
    }
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(ClienteVentas)
